export const getTransactionKey = (transaction: Record<string, any>): string => {
  const { _id, shareFrom, shareTo } = transaction;
  return `${_id}-${shareFrom}-${shareTo}`;
};
